<template>
    <div>
        <MetaDataComponent :title="challengeFilterName + ' Challenges'" :url="this.$route.fullPath"/>
        <div class="row">
            <div class="col-xs-12 col-sm-4 col-lg-4">
                <h3 class="page-header">
                    <i class="fa" :class="challengeFilterIcon"></i>
                    <span>{{ challengeFilterName }} Challenges</span>
                </h3>
            </div>
            <div class="col-lg-offset-2 col-xs-12 col-sm-8 col-lg-6"
                 v-if="challengeGroupsRequest.loaded && !challengeGroupsRequest.error">
                <ChallengeFilter
                    ref="challengeFilter"
                    v-model="searchInput"
                    :languages-retrieved-from-api="loadedLanguages"
                    :allChallengesCheckbox="isAuthenticated"
                    v-on:selectLanguages="filterChallengeGroups"
                    v-on:selectDifficulties="filterChallengeGroups"
                    v-on:sponsoredChange="filterChallengeGroups"
                    v-on:challengeFilterStateChange="onChallengeFilterStateChange"
                />
            </div>
        </div>
        <!-- CHALLENGE OF THE WEEK: enable and disable in data -->
        <div v-if="$features.CHALLENGE_OF_THE_WEEK" class="row">
            <ChallengeOfTheWeek :userProfileRequest="userProfileRequest"/>
        </div>
        <div class="row">
            <transition name="loading-fade">
                <div v-if="!challengeGroupsRequest.loaded && !challengeGroupsRequest.error"
                     class="text-center challenge-error">
                    <content-loader :primary-color="'#F2F7FD'" :secondary-color="'#E0EDFB'" width="1948" height="1233" class="loader-bar"
                                    style="margin: 2rem; width: 20%; max-width: 100%; min-width: 200px;">
                        <path class="cls-1"
                              d="M851.14,806.83C737.79,799.6,610.6,785.89,489.9,757.72l-54.1,45.44C550,833.87,692.7,855.74,851.14,865v185.23c-87.87-5.14-170.87-14.18-246.9-26.42,80.23,59.4,168.67,120.3,246.9,170.85v248c-348.78-209.81-572.42-394.2-750.92-668.38L408.57,583.72c125.77,38.51,277.24,64.61,442.57,73.64Zm125.29-146v855.35l3.85,2.21c86.62-49.62,166.24-97.22,239.77-144.14V1048.74c89.68-6,174-16.16,250.58-29.6v178.5c158-125.3,282.09-258,389.7-423.33L1552,583.72q-39.12,12-81.39,22.3V833.88c-76.57,13.44-160.9,23.56-250.58,29.61V648.6a2316.46,2316.46,0,0,1-239.77,12.26l-3.85,0"
                              transform="translate(-100.22 -583.72)"/>
                    </content-loader>
                </div>
            </transition>
            <transition name="delayed-show">
                <div v-if="challengeGroupsRequest.loaded && !challengeGroupsRequest.error && languageFilterResult"
                     ref="grid"
                     class="challenge-panel" :class="{'error-panel': shownChallengesCount === 0}">
                    <div v-if="shownChallengesCount === 0" class="col-lg-4 col-lg-offset-4 col-sm-12 col-xs-12">
                        <div class="panel">
                            <div class="panel-body text-center" style="margin-bottom: 1rem;">
                                <img src="/assets/icons/search-code.svg" alt="search but nothing found icon"
                                     style="height:80px; display: block; margin: 1rem auto;"/>
                                <h3 class="lead">Keine {{ challengeFilterName !== 'Alle' ? challengeFilterName.toLowerCase() : '' }}{{ showSponsored ? ' gesponserte' : '' }} Challenge gefunden</h3>
                            </div>
                        </div>
                    </div>
                    <div v-for="challengeGroup in challengeGroupList" v-if="challengeGroup.showChallengeGroup"
                         class="col-xs-12 col-lg-4 col-md-6 challenge-component">
                        <challenge-group-component
                                :challengeGroup="challengeGroup"
                                :userHasSolvedAtLeastOneChallenge="userHasSolvedAtLeastOneChallenge"
                                :sponsoredChallenge="getSponsoredChallenge(challengeGroup.id)"
                                :sponsoringInformationLoaded="sponsoringInformationRequest.loaded"
                        />
                    </div>
                </div>
            </transition>
        </div>
        <ErrorComponent v-if="challengeGroupsRequest.error"
                        message="Verfügbare Challenges konnten zur Zeit nicht geladen werden :-("
                        :isError="true"/>
    </div>
</template>

<script>
import {services} from "../main";
    import ErrorComponent from "../components/ErrorComponent";
    import Masonry from 'masonry-layout/masonry.js';
    import {mapState} from 'vuex';
    import {eventBus} from "../main";
    import {ContentLoader, CodeLoader} from "vue-content-loader";
    import ChallengeGroupComponent from "../components/campaigns/ChallengeGroupComponent";
    import ChallengeFilter from "../components/campaigns/ChallengeFilter";
    import ChallengeOfTheWeek from "../components/campaigns/ChallengeOfTheWeek";

    export default {
        name: "campaign-list",
        components: {
          ChallengeOfTheWeek, ChallengeGroupComponent, ErrorComponent, ContentLoader, CodeLoader, ChallengeFilter
        },
        data() {
            return {
                challengeGroupsRequest: {loaded: false, error: null, apiData: []},
                userProfileRequest: {loaded: false, error: null},
                sponsoringInformationRequest: {loaded: false, error: null},
                masonry: null,
                challengeGroups: [],
                languageFilterResult: true,
                searchInput: "",
                showSponsored: false,
                challengeFilterName: 'Alle',
                challengeFilterIcon: 'dev-terminal-box',
            }
        },
        updated() {
            this.$nextTick(() => {
                if (!this.$refs.grid) {
                    return;
                }
                if (this.masonry) {
                    this.masonry.destroy();
                }
                this.masonry = new Masonry(this.$refs.grid, {
                    horizontalOrder: true,
                    itemSelector: ".challenge-component"
                });
                this.masonry.layout();
                // on mobile we have call layout a second time with a timeout
                 setTimeout(() => {
                    this.masonry.layout();
                }, 2400);

                eventBus.$on("sideBarToggle", () => {
                    setTimeout(() => {
                        this.masonry.layout();
                    }, 500)
                });
            });
        },
        created() {
            eventBus.$on("user-profile-changed", () => {
                this.userProfileRequest = services.userService.getUserProfile();
            });
            if (this.isAuthenticated) {
                this.userProfileRequest = services.userService.getUserProfile();
            }
            this.getChallengeGroups();
        },
        computed: {
            shownChallengesCount: function () {
                if (this.languageFilterResult) {
                    return this.challengeGroups.filter(challengeGroup => challengeGroup.showChallengeGroup).length;
                }
            },
            challengeGroupList: function () {
                if (!this.challengeGroupsRequest.loaded || this.challengeGroupsRequest.error) {
                    return [];
                }
                this.challengeGroups = this.challengeGroupsRequest.apiData
                for (let challengeGroup of this.challengeGroups) {
                    challengeGroup.showChallengeGroup = true;
                    challengeGroup.isNew = false;
                    challengeGroup.isAccepted = false;
                    challengeGroup.isSolved = false;
                    for (let challenge of challengeGroup.challenges) {
                        if (challenge.isAccepted) {
                            challengeGroup.isAccepted = true;
                            challengeGroup.showChallengeGroup = false;
                        }
                        if (challenge.isSolved) {
                            challengeGroup.isSolved = true;
                            challengeGroup.showChallengeGroup = false;
                        }
                        if (challenge.isNew) {
                            challengeGroup.isNew = true;
                        }
                    }
                }
                return this.getChallengeGroupsWithRecommendations();
            },
            userHasSolvedAtLeastOneChallenge() {
                for (let challengeGroup of this.challengeGroups) {
                    for (let challenge of challengeGroup.challenges) {
                        if (challenge.isSolved) {
                            return true;
                        }
                    }
                }
                return false;
            },
            loadedLanguages: function () {
                if (!this.challengeGroupsRequest.loaded || this.challengeGroupsRequest.error) {
                    return new Set();
                }

                let loadedLanguages = new Set();
                this.challengeGroups = this.challengeGroupsRequest.apiData;
                for (let challengeGroup of this.challengeGroups) {
                    for (let challenge of challengeGroup.challenges) {
                        loadedLanguages.add(challenge.technology.language.toLowerCase());
                    }
                }

                return loadedLanguages;
            },
            ...mapState(['isAuthenticated'])
        },
        watch: {
            isAuthenticated() {
                this.userProfileRequest = services.userService.getUserProfile();
                this.getChallengeGroups();
            },
            'challengeGroupsRequest.loaded': function () {
                if(this.challengeGroupsRequest.loaded && !this.challengeGroupsRequest.error) {
                    this.getSponsoringInformation();
                }
            },
        },
        methods: {
            isSponsoredChallengeGroup(challengeGroup) {
              let sponsoringInformation = this.getSponsoredChallenge(challengeGroup.id);
              return null != sponsoringInformation;
            },
            isOnboardingChallengeGroup(challengeGroup) {
                if (challengeGroup.title.toLowerCase().search('fizzbuzz') !== -1) {
                    return true;
                }
                return false;
            },
            sortChallengeGroupsByIsOnboardingAndIsNew() {
                this.challengeGroups.sort(function (a, b) {
                    //onboarding challenge should be displayed first but only if you have not solved any challenge yet
                    if (!this.userHasSolvedAtLeastOneChallenge) {
                        if (!a["isOnboardingChallengeGroup"] && b["isOnboardingChallengeGroup"]) {
                            return 1;
                        }
                        if (a["isOnboardingChallengeGroup"] && !b["isOnboardingChallengeGroup"]) {
                            return -1;
                        }
                    }
                    //new challenges follow
                    if (!a["isNew"] && b["isNew"]) {
                      return 1;
                    }
                    if (a["isNew"] && !b["isNew"]) {
                      return -1;
                    }
                    //then sponsored challenges
                    if (!a["isSponsoredChallengeGroup"] && b["isSponsoredChallengeGroup"]) {
                      return 1;
                    }
                    if (a["isSponsoredChallengeGroup"] && !b["isSponsoredChallengeGroup"]) {
                      return -1;
                    }
                    return 0;
                }.bind(this));
            },
            getChallengeGroupsWithRecommendations() {
                this.challengeGroups.forEach(challengeGroup => {
                    challengeGroup.isOnboardingChallengeGroup = this.isOnboardingChallengeGroup(challengeGroup);
                    challengeGroup.isSponsoredChallengeGroup = this.isSponsoredChallengeGroup(challengeGroup);
                });
                this.sortChallengeGroupsByIsOnboardingAndIsNew();
                this.challengeGroups.filter(challengeGroup => challengeGroup.showChallengeGroup).length;
                this.filterChallengeGroups();
                return this.challengeGroups;
            },
            checkIfChallengeGroupShouldBeVisible(challengeGroup, selectedLanguages, selectedDifficulties) {
                const challengeGroupLanguages = this.getLanguagesFromChallengeGroup(challengeGroup);

                let sponsoredChallenge = this.getSponsoredChallenge(challengeGroup.id);
                const isInSponsoredCompanyName = sponsoredChallenge && sponsoredChallenge.name.toLowerCase().includes(this.searchInput.toLowerCase()) ;

                if (this.searchInput !== "") {
                    if (!(challengeGroup.title.toLowerCase().includes(this.searchInput.toLowerCase()) ||
                        challengeGroup.description.toLowerCase().includes(this.searchInput.toLowerCase()) ||
                        isInSponsoredCompanyName

                    )) {
                        return false;
                    }
                }
                if (selectedLanguages.length === 0 && selectedDifficulties.length === 0) {
                  return true;
                }
                let onlyDifficultySelected = selectedLanguages.length === 0 && selectedDifficulties.includes(challengeGroup.complexity);
                let onlyLanguageSelected = selectedDifficulties.length === 0 && selectedLanguages.some(language => challengeGroupLanguages.includes(language));
                let bothSelected = selectedLanguages.some(language => challengeGroupLanguages.includes(language)) && selectedDifficulties.includes(challengeGroup.complexity);

                return onlyDifficultySelected || onlyLanguageSelected || bothSelected;
            },
            filterChallengeGroups: function() {
                // TODO: improve filter method and learn how to filter computed properties with filter from a child component... good night
                // this variable is needed for reactivity
                this.showSponsored = false;
                this.languageFilterResult = false;
                if(this.$refs.challengeFilter) {
                  let selectedLanguages = this.$refs.challengeFilter.$refs.languageFilter.languages.filter(language => {
                    return language.selected === true
                  }).map(item => item.key);

                  let selectedDifficulties = this.$refs.challengeFilter.$refs.difficultyFilter.difficulties.filter(difficulty => {
                    return difficulty.selected === true
                  }).map(item => parseInt(item.complexity));
                  this.showSponsored = this.$refs.challengeFilter.showSponsored;
                  const challengeFilterStateKey = this.$refs.challengeFilter.challengeFilterStateKey;
                  for (let challengeGroup of this.challengeGroups) {
                    switch (challengeFilterStateKey) {
                      case 'all':
                        challengeGroup.showChallengeGroup = true;
                        break;
                      case 'available':
                        challengeGroup.showChallengeGroup = !challengeGroup.isAccepted && !challengeGroup.isSolved;
                        break;
                      case 'new':
                        challengeGroup.showChallengeGroup = challengeGroup.isNew && !challengeGroup.isAccepted && !challengeGroup.isSolved;
                        break;
                      case 'started':
                        challengeGroup.showChallengeGroup = challengeGroup.isAccepted && !challengeGroup.isSolved;
                        break;
                      case 'solved':
                        challengeGroup.showChallengeGroup = challengeGroup.isAccepted && challengeGroup.isSolved;
                        break;
                    }
                    challengeGroup.showChallengeGroup &= !this.showSponsored || challengeGroup.isSponsoredChallengeGroup;
                    if (challengeGroup.showChallengeGroup) {
                      challengeGroup.showChallengeGroup = this.checkIfChallengeGroupShouldBeVisible(challengeGroup, selectedLanguages, selectedDifficulties);
                    }
                  }
                }
                this.languageFilterResult = true;
            },
            onChallengeFilterStateChange: function (challengeFilterState) {
                this.challengeFilterName = challengeFilterState.name;
                this.challengeFilterIcon = challengeFilterState.icon;
                this.filterChallengeGroups();
            },
            getSponsoredChallenge(challengeGroupId) {
                if (!this.sponsoringInformationRequest.loaded) {
                    return null;
                }
                if (this.sponsoringInformationRequest.error) {
                    return null;
                }
                let challengeGroup = this.getChallengeGroup(challengeGroupId);

                if (!challengeGroup) {
                    return null;
                }
                for (let challenge of challengeGroup.challenges) {
                    for (let sponsoringInformation of this.sponsoringInformationRequest.apiData) {
                        if (sponsoringInformation.challengeId === challenge.id) {
                            return sponsoringInformation;
                        }
                    }
                }
                return null;

            },
            getSponsoringInformation() {
                if (!this.challengeGroupsRequest.loaded) {
                    return;
                }
                if (this.challengeGroupsRequest.error) {
                    return;
                }

                let challengeIds = [];
                for (let challengeGroup of this.challengeGroupsRequest.apiData) {
                    for (let challenge of challengeGroup.challenges) {
                        challengeIds.push(challenge.id);
                    }
                }
                this.sponsoringInformationRequest = services.companyService.getPublicSponsoringInformation(challengeIds, true);
            },
            getChallengeGroups(accepted) {
                if (typeof accepted === "undefined") {
                    this.challengeGroupsRequest = services.taskManagementService.getChallengeGroups();
                } else {
                    this.challengeGroupsRequest = services.taskManagementService.getChallengeGroups(accepted);
                }
            },
            getChallengeGroup(challengeGroupId) {
                for (let challengeGroupEntry of this.challengeGroups) {
                    if (challengeGroupEntry.id === challengeGroupId) {
                        return challengeGroupEntry;
                    }
                }
                return null;
            },
            getLanguagesFromChallengeGroup(challengeGroup) {
              let languages = [];
                for (let challenge of challengeGroup.challenges) {
                  languages.push(challenge.technology.language.toLowerCase());
                }
              return languages;
            }
        }
    }
</script>

<style scoped>
    .page-header {
        display: flex;
        align-items: center;
    }
    .page-header i.fa {
        font-size: 3rem;
        margin-right: 1rem;
        vertical-align: middle;
    }
    .accepted_challenges .campaign-link:before {
        content: "\f04c";
        font: normal normal normal 14px/1 FontAwesome;
        color: whitesmoke;
        display: block;
        width: 5rem;
        height: 5rem;
        line-height: 5rem;
        border-radius: 50%;
        background: linear-gradient(to bottom right, #fa8231 0%, #f7b731 100%);
        position: absolute;
        right: 25px;
        top: 25px;
        font-size: 2rem;
        text-align: center;
    }

    .solved_challenge .campaign-link:before {
        content: "\f00c";
        font: normal normal normal 14px/1 FontAwesome;
        color: whitesmoke;
        display: block;
        width: 5rem;
        height: 5rem;
        line-height: 5rem;
        border-radius: 50%;
        background: linear-gradient(to bottom right, #08AB99 0%, #0BC4A2 100%);
        position: absolute;
        right: 25px;
        top: 25px;
        box-shadow: 0px 2px 4px rgba(173, 181, 189, 0.15);
        font-size: 2rem;
        text-align: center;
    }

    .challenge-panel {
        margin-left: 18px;
        margin-top: 2rem;
    }

    .error-panel {
        margin-left: 0;
    }

    .challenge-error {
        height: 120px;
    }

    .challenge-component {
        padding: 0 18px 0 0;
    }


</style>

